import { faMobileAlt, faMapMarkedAlt } from '@fortawesome/free-solid-svg-icons';
import { faBuffer } from '@fortawesome/free-brands-svg-icons'

export const usefulLink = [
    {name: 'Home', id: 1},
    {name: 'About us', id: 2},
    {name: 'Services', id: 3},
   // {name: 'Team', id: 4},
   // {name: 'Blog', id: 5}
]
export const ourServices = [
    {name: 'First Service', id: 6},
    {name: 'Second Service', id: 7},
    {name: 'Third Service', id: 8},
    {name: 'Fourth Service', id: 9},
   // {name: 'Third Service', id: 10}
]
export const otherLinks = [
    {name: 'FAQ', id: 11},
   // {name: 'Portfolio', id: 12},
    {name: 'Privacy Policy', id: 13},
    {name: 'Terms & Conditions', id: 14},
    {name: 'Support', id: 15},
]

export const footerInfo = [
    {icon: faBuffer, info1: 'FINANCEBDARIJA', id: 1},
    {icon: faMobileAlt, info1: '+0000000', info2: 'Admin@gmail.com', id: 2},
    {icon: faMapMarkedAlt, info1: 'Address, USA', info2: 'TN,USA', id: 3}
];